import { AUTHORIZATION_HEADER } from '../../../../../../src/authorization';
import { send } from '../../../../../../src/network';
import { type Address } from '../../../../../../src/types/Address';
import { type PatchedAddress } from '../../../../../../src/types/PatchedAddress';

export type { PatchedAddress };

type Params = {
  requestBody: PatchedAddress;
};

export async function patchApiV2CustomersCustomerIdAddress(params: Params) {
  return await send<Address>({
    path: `/api/v2/customers/self/address/`,
    method: 'PATCH',
    body: params.requestBody,
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  });
}
